import React, { useEffect, useState } from 'react'
import {
    BrowserRouter,Routes, Route
  } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import { DashboardRoutes } from './DashboardRoutes';
import { DashboardPublicRoutes } from './DashboardPublicRoutes';
import {useSelector} from 'react-redux';

// Main App Route to display all routes
export const AppRouter = () => {
    let user = useSelector( state => state.auth ) || { logged: false };
    const [ isLoggedIn, setIsLoggedIn ] = useState(true);

    useEffect(() => {
        if(user?.id || sessionStorage.getItem('userSelect')){
            setIsLoggedIn( true );
        }
        else{
            setIsLoggedIn( false );
        }
        
    }, [user])


    return (
            <BrowserRouter>
                <Routes> 
                    <Route path="auth/*" 
                        element={
                            <PublicRoute isLoggedIn={isLoggedIn}>
                                <DashboardPublicRoutes/>
                            </PublicRoute>
                        }
                    /> 
                   <Route path="/*" 
                        element={
                            <PrivateRoute isLoggedIn={isLoggedIn}>
                                <DashboardRoutes/>
                            </PrivateRoute>
                        }
                    />
                    
                </Routes>
            </BrowserRouter>
    )
}
